module.exports = __webpack_public_path__ + "img/06.72f1939e.png";